<template>
    <select
        v-model="duration"
        :disabled="disabled"
        class="form-control v2-styles dropdown-arrow"
    >
        <option
            v-for="{ value, text } in durationOptions"
            :key="value"
            :value="value"
        >{{ text }}</option>
    </select>
</template>

<script>
    import CheckerDetailRow from '../CheckerDetailRow';

    export default {
        name: 'season-ticket-duration-select',

        components: { CheckerDetailRow },

        props: {
            value: {
                type: [String, Number],
                default() {
                    return '';
                },
            },

            disabled: {
                type: [String, Number, Boolean],
                default() {
                    return false;
                },
            },

            space: {
                type: Object,
                default() {
                    return {};
                },
            },
        },

        computed: {
            duration: {
                get() {
                    return this.value;
                },

                set(val) {
                    this.$emit('input', val);
                },
            },

            /**
             * Remove duplicate interval_count.
             *
             * @returns {Array}
             */
            durationOptions() {
                const seen = new Set();
                return this.space.lt_season_pricing.data
                    .filter(({ billing: { interval_count } }) => !seen.has(interval_count) && seen.add(interval_count))
                    .map(({ billing: { interval_count, interval } }) => ({
                        value: interval_count,
                        text: `${ interval_count } ${ interval }`,
                    }));
            },
        },

        mounted() {
            if (!this.duration) {
                this.duration = this.durationOptions[0].value;
            }
        },
    };
</script>
